import { CustomResponse } from '@/models/custom-response.model';
import { CustomUser } from '@/models/custom-user.model';
import { UserService, PermissionService } from '@/services';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CustomRole } from '@/models/custom-role.model';
import { PERMISSIONS } from '@/constants';

const Notification = namespace('notification');
const Authentication = namespace('authentication');

@Component
export default class UserCreateView extends Vue {
    @Authentication.Getter('hasPermission') private hasPermission: (permission: string) => boolean;
    @Notification.Action('addSuccess') private addSuccess: any;
    @Notification.Action('addError') private addError: any;

    public inFlight: boolean = false;
    public roles: CustomRole[] = [];

    public createUser: any = {
        first_name: '',
        last_name: '',
        email: '',
        role: null,
    };

    get canReadRoles(): boolean {
        return this.hasPermission(PERMISSIONS.Role.READ);
    }

    public mounted(): void {
        if (this.canReadRoles) {
            this.getRoles();
        }
    }

    private async getRoles() {
        this.inFlight = true;
        try {
            const response = await PermissionService.listRoles();
            this.roles = response.data;
            this.inFlight = false;
        } catch (error) {
            this.addError(error.localized, error);
            this.inFlight = false;
        }
    }

    public handleSubmit() {
        const { first_name, last_name, email } = this.createUser;

        if (first_name && last_name && email) {
            this.inFlight = true;
            UserService.create(this.createUser)
                .then(
                    (response: CustomResponse<CustomUser>) => {
                        this.addSuccess(response.localized);
                        this.$router.push({ name: 'userList' });
                        this.inFlight = false;
                    },
                    (error) => {
                        this.addError(error.localized, error);
                        this.inFlight = false;
                    },
                );
        }
    }

}
